export default function scrollTop() {
  const btn = $('.up-page-button');
  btn.click((e) => $('html,body').animate({ scrollTop: 0 }, 1000))
  const historybutton = $('.history-button');
  historybutton.click((e) => $('html,body').animate({ scrollTop: 0 }, 1000))
  
}